import axios from "axios";

const BASE = "/api/public";

export function getTeachers() {
  return axios.get(`${BASE}/teachers`);
}

export function getActiveCourses() {
  return axios.get(`${BASE}/courses/active`);
}

export function getGrades() {
  return axios.get(`${BASE}/grades`);
}
